import type { AxiosResponse } from 'axios'
import axios from '../axios'
import type {
    IAlarmVoicePageListData,
    IAlarmVoicePageListParams,
    IAlarmVoiceSaveSettingParams,
    IAlarmVoiceSetting,
    IAlarmVoiceSettingParams,
} from './alarmVoice.types'

/** 分页查询报警语音推送记录 */
export function alarmVoicePageList(params: IAlarmVoicePageListParams = {}) {
    return axios<IAlarmVoicePageListData>({
        method: 'get',
        url: '/alarmVoice/pageList',
        params,
    })
}

/** 播放报警语音 WAV 文件 */
export function alarmVoiceAudio(recordId: number) {
    return axios<Blob, AxiosResponse<Blob>>({
        method: 'get',
        url: `/alarmVoice/audio/${recordId}`,
        responseType: 'blob',
        rawResponse: true,
    })
}

/** 重试失败的报警语音合成 */
export function alarmVoiceRetry(recordId: number) {
    return axios<void>({
        method: 'post',
        url: `/alarmVoice/retry/${recordId}`,
    })
}

/** 查询当前总公司语音播报配置 */
export function alarmVoiceSetting(params: IAlarmVoiceSettingParams = {}) {
    return axios<IAlarmVoiceSetting>({
        method: 'get',
        url: '/alarmVoice/setting',
        params,
    })
}

/** 保存当前总公司语音播报配置 */
export function alarmVoiceSaveSetting(data: IAlarmVoiceSaveSettingParams) {
    return axios<IAlarmVoiceSetting>({
        method: 'post',
        url: '/alarmVoice/setting',
        data,
    })
}
